import Rebase from "re-base";
import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDDAayGZsETn470lcnW-OFGLgLnxWih_Ys",
  authDomain: "catch-of-the-day-anja-gusev.firebaseapp.com",
  databaseURL: "https://catch-of-the-day-anja-gusev.firebaseio.com"
});

const base = Rebase.createClass(firebaseApp.database());

//this is a named export
export { firebaseApp };

//this is a default export
export default base;
